import Rollbar from "rollbar-browser";

var rollbarConfig = {
  accessToken: "501b05c4d2674a28a2262a3ab9f91e7f",
  captureUncaught: true,
  enabled: process.env.REACT_APP_ENV === "production",
  payload: {
    environment: process.env.REACT_APP_ENV
  }
};

let rollbar = Rollbar.init(rollbarConfig);

export default rollbar;



// WEBPACK FOOTER //
// ./src/utils/Rollbar.js